// extracted by mini-css-extract-plugin
export default {"container":"TestimonialForm_container__RBJ3b","btnContainer":"TestimonialForm_btnContainer__avRBU","error":"TestimonialForm_error__ygeRt"};